import React from 'react'
import {emailRegex} from '../../../../utils'
import {VenueSubmissionFormState} from '../../../../types'

type ErrorFormState = {
  venueName?: string
  addressLine1?: string
  city?: string
  postalCode?: string
  stateOrProvince?: string
  country?: string
  contactName?: string
  contactEmail?: string
  contactPhone?: string
}

const useErrorFormState = (formValues: VenueSubmissionFormState, isStateRequired: boolean) => {
  const [errorFormState, setErrorFormState] = React.useState<ErrorFormState>({})
  React.useEffect(() => {
    const next: ErrorFormState = {}
    const {
      venueName,
      address: {city, postalCode, stateOrProvince, country, addressLine1},
      contact: {contactName, contactEmail, contactPhone},
    } = formValues
    if (!venueName || venueName.trim() === '') {
      next.venueName = 'Venue name is required.'
    }
    if (!addressLine1 || addressLine1.trim() === '') {
      next.addressLine1 = 'Address Line 1 is required.'
    }
    if (!city || city.trim() === '') {
      next.city = 'City is required.'
    }
    if (!postalCode || postalCode.trim() === '') {
      next.postalCode = 'Postal code is required.'
    }
    if (!country || country?.value.trim() === '') {
      next.country = 'Country is required.'
    }
    if (isStateRequired && (!stateOrProvince || stateOrProvince?.value?.trim() === '')) {
      next.stateOrProvince = 'State/Province is required.'
    }
    if (!contactName || contactName.trim() === '') {
      next.contactName = 'Contact name is required.'
    }
    if (contactEmail.length > 0 && !emailRegex.test(contactEmail.trim())) {
      next.contactEmail =
        'Please enter a valid email address. Must be in the format: example@domain.com'
    }
    if (!contactPhone || contactPhone.trim() === '') {
      next.contactPhone = 'Contact phone number is required.'
    }
    setErrorFormState(next)
  }, [formValues, isStateRequired])

  return {errorFormState}
}

export default useErrorFormState
